import { ModelBase } from 'store/model-base';
import { CmsNonXfinityCustomer } from './non-xfinity-customer';

export class CmsXmbComingSoon extends ModelBase {
    public static storeName: string = 'cmsXmbComingSoon';

    public errorData: CmsNonXfinityCustomer;
}
